<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
    <div class="cb-header">
        <!-- 1 抽屉开关 -->
        <div @click="openDrawer"><i class="el-icon-s-unfold cb-header-menu"></i></div>

        <!-- 2 中部 title 和 dropdown 开关 -->
        <div class="cb-header-scenarios">
            <!-- <el-dropdown trigger="click"> -->
            <span class="el-dropdown-link"> {{ scenarioLabel }} </span>
            <!-- <template v-slot:dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item
                            v-for="item in scenarios_dropDown"
                            :key="item.value"
                            @click="onScenarioClick(item.label, item.value)"
                            >{{ item.label }}</el-dropdown-item
                        >
                    </el-dropdown-menu>
                </template> -->
            <!-- </el-dropdown> -->
        </div>

        <!-- 3 系统设置 dropdown 开关 -->
        <div class="cb-header-user">
            <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                    <i class="el-icon-user-solid"></i>
                </span>
                <template v-slot:dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click.native="logout"><i class="el-icon-turn-off"></i>退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>

        <!-- 4 抽屉 -->
        <el-drawer
            id="id_drawer_history"
            :visible.sync="historyDrawerVisible"
            title="我是title"
            custom-class="drawer-custom"
            direction="ltr"
        >
            <template v-slot:title>
                <span>
                    <h3>对话历史</h3>
                </span>
            </template>
            <div class="drawer-custom-content">
                <div class="drawer-custom-content-header">
                    <el-button type="primary" @click="newChat"><i class="el-icon-circle-plus-outline"></i>新建对话</el-button>
                </div>
                <div class="drawer-custom-content-container">
                    <ul class="ul-list">
                        <li v-for="item in chatHistory" :key="item.chat_id">
                            <div style="flex: 1" @click="gotoChat(item.chat_id, item.func_type)">{{ item.chat_title }}</div>
                            <i class="el-icon-close" @click="deleteChat(item.chat_id)"></i>
                        </li>
                    </ul>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
/**
 * 对话页上部的 header，包括左部 drawer 开关、中间 dropdown 开关、右侧系统设置 dropdown 开关
 */
import { careBotApi } from '@/api/carebot';
import store from '@/store';

export default {
    name: 'careBotHeader',
    data() {
        return {
            name: '',
            scenarios_dropDown: [
                {
                    value: 'health_chat',
                    label: '智能自诊',
                },
                {
                    value: 'medication',
                    label: '用药咨询',
                },
            ],
            scenarios: [
                {
                    value: 'home',
                    label: 'Carebot',
                },
                {
                    value: 'none_type',
                    label: '健康问答',
                },
                {
                    value: 'self_diagnosis',
                    label: '病因分析',
                },
                {
                    value: 'health_chat',
                    label: '智能自诊',
                },
                {
                    value: 'medication',
                    label: '用药咨询',
                },
                {
                    value: 'tutor_diagnosis',
                    label: '导诊',
                },
                {
                    value: 'pre_diagnosis',
                    label: '预问诊',
                },
            ],
            historyDrawerVisible: false,
            chatHistory: [],
        };
    },
    computed: {
        scenarioLabel() {
            const route = this.$route;
            const funcType = route.query.funcType || 'home';
            const scenario = this.scenarios.find((option) => option.value === funcType);
            console.log({ funcType, scenario });
            return scenario.label;
        },
        scenarioVal() {
            const route = this.$route;
            const funcType = route.query.funcType || 'home';
            const scenario = this.scenarios.find((option) => option.value === funcType);
            return (scenario && scenario.value) || 'home';
        },
    },
    mounted() {
        // const { name: name_stored_in_cookie } = getUserInfo();
        this.name = '我';

        // 历史会话
        this.getChatHistory();
    },
    methods: {
        openDrawer() {
            console.log('header open history drawer');
            this.historyDrawerVisible = true;
        },
        // 一进入场景，即显示对话历史
        getChatHistory() {
            careBotApi.chatHistory().then((params) => {
                this.chatHistory = params.data || [];
                // this.chatHistory = params.data.filter((v) => v.func_type === 'none_type');
            });
        },
        gotoChat(chatId, funcType) {
            this.historyDrawerVisible = false;
            this.$router.push({
                path: '/chat',
                query: { t: Math.random().toString(36).substring(2), chatId, funcType },
            });
        },
        deleteChat(chat_id) {
            if (store.getters.curActiveChatId === chat_id) {
                this.$message({
                    message: '这个对话正在进行中哦，不能删除',
                    type: 'info',
                    duration: 1500,
                });
                return;
            }
            careBotApi.deleteChatById({ chat_id }).then(() => {
                // TODO 当成功时，后端返回的 code 是 0, 这点不合理
                this.$message({
                    message: '删除成功',
                    type: 'success',
                    duration: 1500,
                });

                // 更新 ui
                this.chatHistory = this.chatHistory.filter((v) => v.chat_id !== chat_id);
            });
        },
        goHome() {
            this.$router.push('/index');
        },
        goSetting() {
            this.$router.push('/index');
        },
        async logout() {
            console.log('btn logout is clicked');
            await this.$store.dispatch('user/logout');
            await this.$router.push('/login');
        },
        onScenarioClick(label, val) {
            if (val === 'home') {
                this.$router.push({
                    path: '/index',
                    query: { t: Math.random().toString(36).substring(2) },
                });
            } else {
                this.$router.push({
                    path: '/chat',
                    query: {
                        t: Math.random().toString(36).substring(2),
                        chatId: '',
                        funcType: val,
                    },
                });
            }
        },
        newChat() {
            this.historyDrawerVisible = false;
            if (this.scenarioVal === 'home') {
                this.$router.push({
                    path: '/chat',
                    query: { t: Math.random().toString(36).substring(2) },
                });
            } else {
                this.$router.push({
                    path: '/chat',
                    query: {
                        t: Math.random().toString(36).substring(2),
                        chatId: '',
                        funcType: this.scenarioVal,
                    },
                });
            }
        },
    },
};
</script>

<style lang="scss">
.cb-header {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);

    .cb-header-menu {
        width: 50px;
        padding-left: 20px;
        font-size: 30px;
        cursor: pointer;
    }

    .cb-header-scenarios {
        width: calc(100% - 110px);
        text-align: center;
        font-size: 28px;

        .el-dropdown-link {
            color: #0096ff;
            font-size: 18px;
            font-family: YouSheBiaoTiHei;
            font-weight: normal;

            i {
                font-size: 14px;
                padding-left: 5px !important;
            }
        }
    }

    .cb-header-user {
        width: 60px;

        .el-dropdown-link {
            i {
                color: #ffffff;
                font-size: 18px;
                background-color: rgb(0, 150, 255);
                width: 40px;
                height: 40px;
                border-radius: 50% 50%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    .drawer-custom {
        width: 260px !important;

        .el-drawer__header {
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            margin-bottom: 0 !important;
            padding: 0 20px !important;
            line-height: 45px;

            h3 {
                color: #0096ff;
                font-size: 18px;
                font-family: YouSheBiaoTiHei;
                font-weight: normal;
            }
        }

        .drawer-custom-content {
            position: relative;

            .drawer-custom-content-header {
                position: fixed;
                width: 260px;
                height: 60px;
                padding-top: 10px;
                padding-left: 20px;
                background-color: #ffffff;
                z-index: 1;

                button {
                    width: 220px;

                    i {
                        padding-right: 5px;
                    }
                }
            }

            .drawer-custom-content-container {
                position: relative;
                padding-top: 60px;

                ul {
                    list-style-type: none;
                    margin: 8px;

                    li {
                        width: 100%; // 220px;
                        height: 40px;
                        padding-left: 8px;
                        line-height: 40px;
                        color: #84878c;
                        cursor: pointer;
                        border: 1px solid #dcdfe6;
                        border-radius: 4px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        margin-bottom: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        &.on {
                            background-color: rgba(0, 0, 0, 0.15);
                        }

                        .el-icon-close {
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/carebot/header.vue